import api from './api';

export const patientTrackingService = {
  // CRUD Operations
  async createPatient(patientData) {
    return api.post('/patients', patientData);
  },

  async getPatients() {
    return api.get('/patients');
  },

  async getPatient(patientId) {
    return api.get(`/patients/${patientId}`);
  },

  async updatePatient(patientId, patientData) {
    return api.put(`/patients/${patientId}`, patientData);
  },

  async deletePatient(patientId) {
    return api.delete(`/patients/${patientId}`);
  },

  // Location & Tracking
  async getCurrentLocation(patientId) {
    return api.get(`/patients/${patientId}/location`);
  },

  async getMovementHistory(patientId, startDate, endDate) {
    return api.get(`/patients/${patientId}/history`, {
      params: { startDate, endDate }
    });
  },

  // Beacon Management
  async associateBeacon(patientId, beaconData) {
    return api.put(`/patients/${patientId}/beacon`, beaconData);
  },

  // Restrictions & Safety
  async updateRestrictions(patientId, restrictions) {
    return api.put(`/patients/${patientId}/restrictions`, restrictions);
  },

  // Alerts
  async sendFallAlert(patientId, alertData) {
    return api.post(`/patients/${patientId}/fall-alert`, alertData);
  }
};

export default patientTrackingService;